import { ICreateClientRequest } from "../../../model/base/request/create-client-request";
import { IListClientsRequest } from "../../../model/base/request/list-clients-request";
import { IDashboardResponse } from "../../../model/official-daily/response/dashboard-response";
import { IListDocumentTypesResponse } from "../../../model/official-daily/response/list-document-types-response";
import HttpClient from "../../services/http-client";
import ApplicationAppService from "../application-app-service";
import { IClientDetailResponse } from "../../../model/base/response/client-detail-response";
import { serialize } from "object-to-formdata";
import { IUpdateClientRequest } from "../../../model/base/request/update-client-request";
import { PaginationResponse } from "../../../model/base/response/pagination-response";
import { IListClientsResponse } from "../../../model/official-daily/response/list-clients-response";

const defaultPath = 'Base';

let applicationData = ApplicationAppService.getApplicationData();

var baseUrl = applicationData.officialDailyUrl;

const listDocumentTypes = async (): Promise<IListDocumentTypesResponse[]> => {
    return await HttpClient.executeRequest({
        baseURL: baseUrl,
        method: 'get',
        url: `/${defaultPath}/documentTypes`
    }).then((response) => Object.assign([] as unknown as IListDocumentTypesResponse, response.data));
};


const getDashboard = async (): Promise<IDashboardResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/dashboard`
    }).then((response) => Object.assign({} as unknown as IDashboardResponse, response.data));
};


const listClients = async (params: IListClientsRequest): Promise<PaginationResponse<IListClientsResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
   url: `/${defaultPath}/Clients`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IListClientsResponse>(), response.data));
};

const getClientById = async (id: number): Promise<IClientDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Clients/${id}`
    }).then((response) => Object.assign({} as IClientDetailResponse, response.data));
};

const createClient = async (params: ICreateClientRequest, brandLogo: File | null): Promise<IClientDetailResponse> => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    if (brandLogo) {
        formData.append("brandLogo", brandLogo);
    }
    return await HttpClient.executeRequest({
        method: 'post',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/Clients`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }).then((response) => Object.assign({} as IClientDetailResponse, response.data));
};

const updateClient = async (params: IUpdateClientRequest, brandLogo: File | null): Promise<IClientDetailResponse> => {

    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    if (brandLogo) {
        formData.append("brandLogo", brandLogo);
    }

    return await HttpClient.executeRequest({
        method: 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/Base/Clients/${params.id}`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }).then((response) => Object.assign({} as IClientDetailResponse, response.data));
};

const BaseAppService = {
     listDocumentTypes, getDashboard, listClients, getClientById, createClient, updateClient
};

export default BaseAppService;